module.exports = __webpack_public_path__ + "img/alphaexpress_charge_logo.9e0223df.png";